import axios from '../../axios/index.js';

export default {
    /**
     * Retrieves RFI data.
     *
     * @param rfiId RFI ID
     *
     * @returns {*}
     */
    getRfi (rfiId) {
        return axios.get('/api/v1/rfi/' + rfiId);
    },

    /**
     * Retrieves RFI allowed recipients.
     *
     * @param rfiId RFI ID
     *
     * @returns {*}
     */
    getAllowedRecipients (rfiId) {
        return axios.get('/api/v1/rfi/recipients/' + rfiId);
    },

    /**
     * Get RFI file upload URL.
     *
     * @param rfiId RFI ID
     * @param fileName File name
     *
     * @returns {*}
     */
    getFileUploadUrl (rfiId, fileName) {
        return axios.get('/api/v1/rfi/file-upload-url/' + rfiId, {
            params: {
                file_name: fileName,
            },
        });
    },

    /**
     * Posts new RFI request.
     *
     * @param rfiId RFI ID
     * @param recipients RFI recipients array
     * @param message RFI message
     * @param attachments Attached files array
     *
     * @returns {*}
     */
    postConversation (rfiId, recipients, message, attachments) {
        let formData = new FormData();

        for (let i = 0; i < recipients.length; i++) {
            if (recipients[i] == null) {
                continue;
            }

            formData.append('recipients[' + i + ']', recipients[i].id);
        }

        formData.append('message', message);

        for (let i = 0; i < attachments.length; i++) {
            formData.append('attachments[' + i + ']', attachments[i].file);
        }

        return axios.post('/api/v1/rfi/' + rfiId, formData);
    },

    /**
     * Posts new message to RFI conversation.
     *
     * @param conversationId RFI conversation ID
     * @param message RFI message
     * @param attachments Attached files array
     * @param isRfi Is RFI or an answer
     *
     * @returns {*}
     */
    postMessage (conversationId, message, attachments, isRfi) {
        let formData = new FormData();

        formData.append('message', message);

        for (let i = 0; i < attachments.length; i++) {
            formData.append('attachments[' + i + ']', attachments[i].file);
        }

        formData.append('is_rfi', isRfi ? '1' : '0');

        return axios.post('/api/v1/rfi/conversation/' + conversationId, formData);
    },

    /**
     * Posts mark messages as seen.
     *
     * @param conversationId RFI conversation ID
     *
     * @returns {*}
     */
    postMessagesSeen (conversationId) {
        return axios.post('/api/v1/rfi/conversation/seen/' + conversationId);
    },
};
